'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_MODAL_OPEN = exports.ERROR_MODAL_OPEN = 'ERROR_MODAL_OPEN';
var ERROR_MODAL_CLOSE = exports.ERROR_MODAL_CLOSE = 'ERROR_MODAL_CLOSE';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/errorModalConstants.js
// module id = 431
// module chunks = 0